var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M20 9.9999C20 4.47705 15.5229 -9.91821e-05 10 -9.91821e-05C4.47715 -9.91821e-05 0 4.47705 0 9.9999C0 14.9912 3.65686 19.1282 8.4375 19.8784V12.8905H5.89844V9.9999H8.4375V7.79678C8.4375 5.29053 9.93043 3.90615 12.2146 3.90615C13.3087 3.90615 14.4531 4.10146 14.4531 4.10146V6.5624H13.1921C11.9499 6.5624 11.5625 7.33324 11.5625 8.12406V9.9999H14.3359L13.8926 12.8905H11.5625V19.8784C16.3431 19.1282 20 14.9912 20 9.9999Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M13.8925 12.8906L14.3359 10H11.5625V8.12416C11.5625 7.33334 11.9499 6.5625 13.1921 6.5625H14.4531V4.10156C14.4531 4.10156 13.3087 3.90625 12.2146 3.90625C9.93038 3.90625 8.43744 5.29062 8.43744 7.79688V10H5.89838V12.8906H8.43744V19.8785C8.94657 19.9584 9.46838 20 9.99995 20C10.5315 20 11.0533 19.9584 11.5625 19.8785V12.8906H13.8925Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5d5f3e1f050c434b56b0221f533d6f9f.svg";
export { ForwardRef as ReactComponent };